import { getAccountStore } from '../storage/stores';
import { translate } from '../lib/i18n/core';
import { getBrowserLanguage } from '../sideEffects/browser/core';

export const t = (str: string, variables: Record<string, string> = {}) =>
  replaceShortCodes(translate(str, getAccountLocale()), variables);

const mapLocaleToAppLocales = (locale: string) =>
  ['pt', 'pt-pt', 'pt-br'].includes(locale) ? 'pt_BR' : locale;

const getAccountLocale = () =>
  mapLocaleToAppLocales(
    getAccountStore().get()?.locale || getBrowserLanguage()
  );

const replaceShortCodes = (
  template: string,
  variables: Record<string, string>
): string => {
  return template.replace(
    /{{([^{}]+)}}/g,
    (match, variable) => variables[variable] || match
  );
};
